import events from './events'
import store from 'reducers'
import Actions from './Actions'
import { SessionActions, PageActions, AppointmentActions, PatientActions } from 'actions'

export default class AccountActions extends Actions{
    static get target(){
        return 'account'
    }
    
    static onAccountSubmit (value) {
        events.trigger('Account.accountDidSubmit', value)
    }

    static fetch (data) {
        return this.client.accounts.fetch(data).then((response)=>{
            //JUST USING THIS TO CHECK IF ACCOUNT EXISTS, NAME IT SOMETHING ELSE
            return response
        })
    }

    static set(data){
        events.trigger('Account.accountDidSubmit', data)
        return SessionActions.setAccount(data)
    }

    static create (data) {
        return this.client.accounts.create({
            ...data,
            organizationID: store.getState().organization.id
        }).then((response)=>{
            SessionActions.set({
                ...response.data,
                isReturning: false
            })
            
            return this.grant({organizationID: store.getState().organization.id})
        })
    }

    static update (data) {
        return this.client.accounts.update(data).then((response)=>{
            let session = store.getState().session
            delete session.resetPassword
            SessionActions.set({
                ...session,
                account: response.data
            })
        })
    }

    static authenticate (data) {
        return this.client.accounts.authenticate(data).then((response)=>{
            SessionActions.set({
                ...response.data,
                isReturning: true
            })
            AppointmentActions.fetch()

            return PatientActions.fetch({organizationID: store.getState().organization.id})
        })
    }

    static grant (data) {
        return this.client.organizations.accounts.grant(data).then((response)=>{
            SessionActions.setAccess(store.getState().organization)
        })
    }

    static resetPassword (data) {
        return this.client.accounts.resetPassword(data)
    }

    static fetchSession(){
        return this.client.accounts.fetchSession().then(({data})=>{
            SessionActions.set({
                ...data,
                isReturning: true
            })
            return PatientActions.fetch({organizationID: store.getState().config.organizationID})
        }).catch((e)=>{
            SessionActions.set({})

            PageActions.reset()
        })
    }
}


// WEBPACK FOOTER //
// ./actions/AccountActions.js